export default {
  setFeatures ({ commit }, features) {
    commit('SET_FEATURES', features)
  },
  toggleMode ({ commit }) {
    commit('TOGGLE_MODE')
  },
  setMode ({ commit }, value) {
    commit('SET_MODE', value)
  },
  setKeyword ({ commit }, value) {
    commit('SET_KEYWORD', value)
  },
  setNumber ({ commit }, number) {
    commit('SET_NUMBER', number)
  },
  setIsSearching ({ commit }, value) {
    commit('SET_IS_SEARCHING', value)
  },
  setSearchResults ({ commit }, value) {
    commit('SET_SEARCH_RESULTS', value)
  },
  setHasSearched ({ commit }, value) {
    commit('SET_HAS_SEARCHED', value)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dialer/actions.js